/* [RR feat] Rezepte-Übersicht: Suche, Filter, Nachladen. Daten stehen als
   data-Attribute an den Karten; nichts wird an einen Server geschickt. */
(function () {
  'use strict';

  var DAUER_LABEL = { '15': 'bis 15 Min.', '30': 'bis 30 Min.', '45': 'bis 45 Min.', '999': 'über 45 Min.' };

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ß/g, 'ss').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  /* „Kartoffeln“ → „kartoffel“, „Äpfel“ → „apfel“ (grob, reicht für Zutaten) */
  function stem(t) {
    if (t.length <= 4) return t;
    return t.replace(/(nen|en|er|es|n|s|e)$/, '');
  }

  class RrRezepte extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-rr-grid]');
      this.input = this.querySelector('[data-rr-search] input');
      this.form = this.querySelector('[data-rr-search]');
      this.count = this.querySelector('[data-rr-count]');
      this.empty = this.querySelector('[data-rr-empty]');
      this.reset = this.querySelector('[data-rr-reset]');
      this.clear = this.querySelector('[data-rr-clear]');
      this.moreBtn = this.querySelector('[data-rr-more]');
      this.active = this.querySelector('[data-rr-active]');
      this.pages = parseInt(this.dataset.pages, 10) || 1;
      this.loadedPages = 1;
      this.state = { q: '', zutat: [], dauer: [], level: [], art: [], saison: [] };
      this.synonyme = this.parseSynonyme(this.dataset.synonyme);

      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.apply(); });
      this.input.addEventListener('input', () => { this.state.q = this.input.value; this.debounce(); });
      if (this.clear) this.clear.addEventListener('click', () => { this.input.value = ''; this.state.q = ''; this.apply(); this.input.focus(); });
      this.addEventListener('click', (e) => {
        var chip = e.target.closest('[data-rr-chip]');
        if (chip) { this.toggle(chip.dataset.group, chip.dataset.value); return; }
        if (e.target.closest('[data-rr-reset]')) { this.resetAll(); return; }
        var gt = e.target.closest('[data-rr-group-toggle]');
        if (gt) { this.openGroup(gt.dataset.rrGroupToggle); return; }
        var ac = e.target.closest('[data-rr-active-chip]');
        if (ac) { this.toggle(ac.dataset.group, ac.dataset.value); return; }
        if (e.target.closest('[data-rr-more]')) { this.loadMore(); return; }
      });

      this.fold();
      this.readUrl();
      /* Mit aktivem Filter oder Suche sollen alle Rezepte im Spiel sein. */
      if (this.hasQuery()) this.loadAll().then(() => this.apply()); else this.apply();
    }

    /* Lange Zutatenlisten einklappen: die ersten 14 Chips, der Rest hinter „alle zeigen“ */
    fold() {
      var wrap = this.querySelector('[data-rr-chips="zutat"]');
      if (!wrap) return;
      var chips = Array.prototype.slice.call(wrap.querySelectorAll('[data-rr-chip]'));
      var old = wrap.querySelector('[data-rr-fold]'); if (old) old.remove();
      if (chips.length <= 16) { chips.forEach((c) => c.classList.remove('is-folded')); return; }
      var active = this.state ? this.state.zutat : [];
      chips.forEach((c, i) => c.classList.toggle('is-folded', i >= 14 && active.indexOf(c.dataset.value) < 0 && !this.unfolded));
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'rr-rz__chip rr-rz__chip--toggle'; btn.setAttribute('data-rr-fold', '');
      btn.textContent = this.unfolded ? 'weniger zeigen' : '+ ' + (chips.length - 14) + ' weitere';
      btn.addEventListener('click', () => { this.unfolded = !this.unfolded; this.fold(); });
      wrap.appendChild(btn);
    }

    /* Eine Gruppe (Zutat, Dauer, …) aufklappen; ein zweiter Klick schließt sie wieder */
    openGroup(name) {
      var self = this;
      this.querySelectorAll('[data-rr-group]').forEach(function (g) {
        var open = g.dataset.rrGroup === name && g.hidden;
        g.hidden = !open;
      });
      this.querySelectorAll('[data-rr-group-toggle]').forEach(function (b) {
        var g = self.querySelector('[data-rr-group="' + b.dataset.rrGroupToggle + '"]');
        b.setAttribute('aria-expanded', g && !g.hidden ? 'true' : 'false');
      });
      if (name === 'zutat') this.fold();
    }

    /* Aktive Filter als Chips unter der Suche, jeder Klick entfernt den Wert */
    renderActive() {
      if (!this.active) return;
      var html = '';
      var self = this;
      ['zutat', 'dauer', 'level', 'art', 'saison'].forEach(function (g) {
        self.state[g].forEach(function (v) {
          var label = g === 'dauer' ? (DAUER_LABEL[v] || v) : v;
          html += '<button type="button" class="rr-rz__active-chip" data-rr-active-chip data-group="' + g + '" data-value="' + v.replace(/"/g, '&quot;') + '" aria-label="Filter ' + label.replace(/"/g, '&quot;') + ' entfernen">' + label.replace(/</g, '&lt;') + '<span aria-hidden="true">&times;</span></button>';
        });
      });
      this.active.innerHTML = html;
      ['zutat', 'dauer', 'level', 'art', 'saison'].forEach(function (g) {
        var badge = self.querySelector('[data-rr-group-count="' + g + '"]');
        if (badge) { badge.textContent = self.state[g].length; badge.hidden = self.state[g].length === 0; }
      });
    }

    parseSynonyme(text) {
      var map = {};
      String(text || '').split(/\r?\n/).forEach((line) => {
        var i = line.indexOf('=');
        if (i > 0) map[norm(line.slice(0, i))] = norm(line.slice(i + 1));
      });
      return map;
    }

    debounce() { clearTimeout(this.timer); this.timer = setTimeout(() => this.apply(), 160); }

    hasQuery() {
      var s = this.state;
      return !!(s.q || s.zutat.length || s.dauer.length || s.level.length || s.art.length || s.saison.length);
    }

    readUrl() {
      var p = new URLSearchParams(location.search);
      this.state.q = p.get('q') || '';
      this.input.value = this.state.q;
      ['zutat', 'dauer', 'level', 'art', 'saison'].forEach((g) => {
        var v = p.get(g); this.state[g] = v ? v.split(',').filter(Boolean) : [];
      });
    }

    writeUrl() {
      var p = new URLSearchParams();
      if (this.state.q) p.set('q', this.state.q);
      ['zutat', 'dauer', 'level', 'art', 'saison'].forEach((g) => { if (this.state[g].length) p.set(g, this.state[g].join(',')); });
      var qs = p.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
    }

    toggle(group, value) {
      var list = this.state[group];
      var i = list.indexOf(value);
      if (i >= 0) list.splice(i, 1); else list.push(value);
      if (this.loadedPages < this.pages) this.loadAll().then(() => this.apply()); else this.apply();
    }

    resetAll() {
      this.state = { q: '', zutat: [], dauer: [], level: [], art: [], saison: [] };
      this.input.value = '';
      this.apply();
    }

    /* Suchbegriff gegen den Suchtext der Karte: jedes Wort muss als Wortanfang vorkommen,
       in Grundform (kartoffeln → kartoffel) oder über die Synonymliste. */
    matchesQuery(card, tokens) {
      if (!tokens.length) return true;
      var hay = ' ' + norm(card.dataset.search) + ' ';
      return tokens.every((t) => {
        var cands = [t, stem(t)];
        if (this.synonyme[t]) cands.push(this.synonyme[t]);
        return cands.some((c) => c && hay.indexOf(' ' + c) >= 0);
      });
    }

    matchesFilters(card) {
      var s = this.state;
      if (s.zutat.length) {
        var z = (card.dataset.zutat || '').split('|');
        if (!s.zutat.some((v) => z.indexOf(v) >= 0)) return false;
      }
      if (s.dauer.length) {
        var d = parseInt(card.dataset.dauer, 10) || 0;
        var ok = s.dauer.some((v) => { var lim = parseInt(v, 10); return lim === 999 ? d > 45 : (d > 0 && d <= lim); });
        if (!ok) return false;
      }
      if (s.level.length && s.level.indexOf(card.dataset.level) < 0) return false;
      if (s.art.length && s.art.indexOf(card.dataset.art) < 0) return false;
      if (s.saison.length) {
        var sa = (card.dataset.saison || '').split('|');
        if (!s.saison.some((v) => sa.indexOf(v) >= 0)) return false;
      }
      return true;
    }

    apply() {
      var tokens = norm(this.state.q).split(' ').filter(Boolean).map((t) => this.synonyme[t] || t);
      var cards = Array.prototype.slice.call(this.grid.querySelectorAll('[data-rr-card]'));
      var shown = 0;
      cards.forEach((c) => {
        var ok = this.matchesQuery(c, tokens) && this.matchesFilters(c);
        c.hidden = !ok; if (ok) shown++;
      });
      this.querySelectorAll('[data-rr-chip]').forEach((chip) => {
        var on = this.state[chip.dataset.group].indexOf(chip.dataset.value) >= 0;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.renderActive();
      var active = this.hasQuery();
      if (this.count) this.count.textContent = shown === 1 ? '1 Rezept' : shown + ' Rezepte' + (active ? ' gefunden' : '');
      if (this.empty) this.empty.hidden = shown > 0;
      if (this.reset) this.reset.hidden = !active;
      if (this.clear) this.clear.hidden = !this.state.q;
      var wrap = this.querySelector('[data-rr-more-wrap]');
      if (wrap) wrap.hidden = active || this.loadedPages >= this.pages;
      this.writeUrl();
    }

    /* Weitere Seiten über die Section Rendering API holen und Karten anhängen */
    fetchPage(n) {
      var url = this.dataset.base + '?page=' + n + '&section_id=' + this.dataset.section;
      return fetch(url).then((r) => r.text()).then((html) => {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-rr-card]').forEach((c) => this.grid.appendChild(c));
        /* neue Filterwerte (Zutat, Gericht) ergänzen */
        ['zutat', 'art'].forEach((g) => {
          var mine = this.querySelector('[data-rr-chips="' + g + '"]');
          if (!mine) return;
          var have = Array.prototype.map.call(mine.querySelectorAll('[data-rr-chip]'), (b) => b.dataset.value);
          doc.querySelectorAll('[data-rr-chips="' + g + '"] [data-rr-chip]').forEach((b) => { if (have.indexOf(b.dataset.value) < 0) mine.appendChild(b); });
        });
        this.fold();
      });
    }

    loadMore() {
      if (this.loadedPages >= this.pages || this.loading) return;
      this.loading = true; if (this.moreBtn) this.moreBtn.disabled = true;
      this.fetchPage(this.loadedPages + 1).then(() => { this.loadedPages++; }).catch(() => {}).then(() => {
        this.loading = false; if (this.moreBtn) this.moreBtn.disabled = false; this.apply();
      });
    }

    loadAll() {
      if (this.allPromise) return this.allPromise;
      var chain = Promise.resolve();
      for (var n = this.loadedPages + 1; n <= this.pages; n++) {
        (function (page, self) { chain = chain.then(() => self.fetchPage(page)).then(() => { self.loadedPages = Math.max(self.loadedPages, page); }); })(n, this);
      }
      this.allPromise = chain.catch(() => {});
      return this.allPromise;
    }
  }
  if (!customElements.get('rr-rezepte')) customElements.define('rr-rezepte', RrRezepte);
})();
